import { render, staticRenderFns } from "./sectionUserDetail.vue?vue&type=template&id=7c2e8afa"
import script from "./sectionUserDetail.vue?vue&type=script&lang=js"
export * from "./sectionUserDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports